import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-tandc',
  imports: [],
  templateUrl: './tandc.component.html',
  styleUrl: './tandc.component.css'
})
export class TandcComponent {
  @Output() showTermsEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  onBackClick() {
    this.showTermsEmitter.emit(false);
  }
}
